import { render, staticRenderFns } from "./SidebarItemList.vue?vue&type=template&id=42a041f9&scoped=true&"
import script from "./SidebarItemList.vue?vue&type=script&lang=js&"
export * from "./SidebarItemList.vue?vue&type=script&lang=js&"
import style0 from "./SidebarItemList.vue?vue&type=style&index=0&id=42a041f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a041f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VList})
